import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SalesOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/sales-orders`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders(response.data);
    } catch (error) {
      toast.error('Failed to fetch sales orders');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full" data-testid="sales-orders-loading">
        Loading sales orders...
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="sales-orders-page">
      <div>
        <h1 className="text-3xl font-heading font-bold text-primary" data-testid="sales-orders-title">
          Sales Orders
        </h1>
        <p className="text-slate-600 mt-1" data-testid="sales-orders-subtitle">
          Manage sales orders and dispatch
        </p>
      </div>

      <div className="space-y-4">
        {orders.map((order) => (
          <Card key={order.id} className="border-slate-200 shadow-sm" data-testid={`so-card-${order.id}`}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-heading font-bold text-lg text-primary" data-testid={`so-number-${order.id}`}>
                    {order.order_number}
                  </h3>
                  <p className="text-sm text-slate-600" data-testid={`so-customer-${order.id}`}>
                    Customer: {order.customer_name}
                  </p>
                  <p className="text-xs text-slate-500" data-testid={`so-date-${order.id}`}>
                    {new Date(order.created_at).toLocaleDateString()}
                  </p>
                </div>
                <span className={`status-badge status-${order.status}`} data-testid={`so-status-${order.id}`}>
                  {order.status}
                </span>
              </div>

              <div className="mt-4 flex justify-end">
                <div className="text-right space-y-1">
                  <p className="text-sm text-slate-600">
                    Subtotal: <span className="font-mono" data-testid={`so-subtotal-${order.id}`}>₹{order.subtotal.toFixed(2)}</span>
                  </p>
                  <p className="text-lg font-heading font-bold text-primary">
                    Total: <span className="font-mono" data-testid={`so-total-amount-${order.id}`}>₹{order.total_amount.toFixed(2)}</span>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}

        {orders.length === 0 && (
          <Card className="border-slate-200">
            <CardContent className="text-center py-12 text-slate-500" data-testid="no-orders-message">
              No sales orders found.
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

export default SalesOrders;
